import React from 'react';
import { FormattedMessage } from 'react-intl';

/**
 * Enhanced IntlMessages component
 * Wrapper around FormattedMessage with better TypeScript support
 *
 * @example
 * <IntlMessages id="sidebar.dashboard" />
 * <IntlMessages id="welcome.message" values={{ name: 'John' }} />
 */
export interface IntlMessagesProps {
  id: string;
  defaultMessage?: string;
  values?: Record<string, any>;
  description?: string;
  tagName?: React.ElementType;
}

export const IntlMessages: React.FC<IntlMessagesProps> = (props) => {
  // FormattedMessage accepts these props directly
  return (
    <FormattedMessage
      id={props.id}
      defaultMessage={props.defaultMessage}
      values={props.values}
    />
  );
};

/**
 * Legacy export for backward compatibility
 * @deprecated Use IntlMessages component or useTranslation hook instead
 */
const InjectMessages = (props: any) => <FormattedMessage {...props} />;
export default InjectMessages;
